// @flow

import {adaptGeneric} from '../adapt-generic';

const colorIdMap = {
    "1005": "silver",
    "1017": "black",
    "1018": "gray",
    "1019": "red",
    "1020": "pink",
    "1021": "blue",
    "1022": "green",
    "1023": "brown",
    "1026": "gold",
    "1028": "purple",
    "1029": "white",
    "1031": "yellow",
    "1034": "orange",
    "1040": "beige",
};

const assignColorValue = option => ({
    ...option,
    value: colorIdMap[option.id] || option.name,
});

export const adaptColor = (facet: Facet): FacetWithApplied => (
    adaptGeneric(facet, assignColorValue)
);